import { QueryClient } from '@tanstack/react-query'
import { persistQueryClient } from '@tanstack/react-query-persist-client'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes standard freshness
            gcTime: 24 * 60 * 60 * 1000, // 24 hours persistent cache
            retry: 1, // Only retry failed requests once
            refetchOnWindowFocus: true, // Keep UI fresh when user returns to app
        },
    },
})

// Persist ONLY the hashtags query to localStorage.
// Picks and collections are always fresh from the server on launch.
// This means on cold start, categories appear in ~1ms from disk.
const persister = createSyncStoragePersister({
    storage: window.localStorage,
    key: 'shuvo-hashtag-cache',
})

persistQueryClient({
    queryClient,
    persister,
    maxAge: 24 * 60 * 60 * 1000, // 24h max cache age
    buster: 'v1',                  // bump this to force-clear on breaking changes
    dehydrateOptions: {
        shouldDehydrateQuery: (query) =>
            // Only persist the hashtag registry, nothing else
            query.queryKey[0] === 'hashtags',
    },
})
